var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"red-packet-container"},[_c('div',{staticClass:"red-packet"},[_c('div',{staticClass:"red-packet-cover"},[_c('div',{staticClass:"red-packet-icon"},[_vm._v("🧧")]),_c('div',{staticClass:"red-packet-text"},[_vm._v(_vm._s(_vm.text))])]),_c('div',{staticClass:"red-packet-ribbon"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }